module.exports = __webpack_public_path__ + "static/media/Mamoswine_gaussian2.c1b46606.png";